import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ContactMapping from './ContactMapping'
import ExternalOutboundNumberSelect from './ExternalOutboundNumberSelect'
import PhoneNumberPurchaseForm from './PhoneNumberPurchaseForm'
import RemindersMessageReport from '../../common/RemindersMessageReport'
import LocationActive from './LocationActive'
import CustomMentionValues from './CustomMentionValues'

import { formatReminderNumWithoutCC } from '../../services/utils'
import css from './location-row.css'
import ExtensionSelection from './ExtensionSelection'

class LocationRow extends Component {
  static propTypes = {
    availableExtensions: PropTypes.arrayOf(PropTypes.object).isRequired,
    businesses: PropTypes.arrayOf(PropTypes.object).isRequired,
    buyPhoneNumbers: PropTypes.func.isRequired,
    contactInfo: PropTypes.shape({
      active: PropTypes.bool,
      additionalRecipients: PropTypes.string,
      doctorId: PropTypes.string,
      fEmailEnd: PropTypes.string,
      fEmailStart: PropTypes.string,
      messageReportEmails: PropTypes.string,
      officeEmail: PropTypes.string,
      officePhone: PropTypes.string,
    }).isRequired,
    customMentionValues: PropTypes.arrayOf(PropTypes.object).isRequired,
    doctors: PropTypes.arrayOf(PropTypes.object).isRequired,
    dso: PropTypes.bool.isRequired,
    emailsValidation: PropTypes.shape({
      errors: PropTypes.objectOf(PropTypes.shape({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
      })).isRequired,
      isValid: PropTypes.bool.isRequired,
      validStateByLocationId: PropTypes.objectOf(PropTypes.bool).isRequired,
    }).isRequired,
    externalOutboundNumbers: PropTypes.arrayOf(PropTypes.object).isRequired,
    isTopsAdmin: PropTypes.bool.isRequired,
    location: PropTypes.shape({
      city: PropTypes.string,
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      office_email: PropTypes.string,
      street_address: PropTypes.string,
      timezone: PropTypes.string,
      website: PropTypes.string,
      external_outbound_number_id: PropTypes.string,
    }).isRequired,
    locations: PropTypes.arrayOf(PropTypes.object).isRequired,
    messageReportEmails: PropTypes.string.isRequired,
    pms: PropTypes.string.isRequired,
    practiceId: PropTypes.string.isRequired,
    purchasedNumbers: PropTypes.arrayOf(PropTypes.object).isRequired,
    refetchLocations: PropTypes.func.isRequired,
    requiresPhoneNumberPurchase: PropTypes.bool.isRequired,
    saveContactInfo: PropTypes.func.isRequired,
    saveCustomMentionValue: PropTypes.func.isRequired,
    selectedExtensions: PropTypes.arrayOf(PropTypes.number).isRequired,
    showDoctorSelect: PropTypes.bool.isRequired,
    showAdditionalRecipients: PropTypes.bool.isRequired,
    smseUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
    updateExtensions: PropTypes.func.isRequired,
    voip: PropTypes.bool.isRequired,
    saveLocationActive: PropTypes.func.isRequired,
    reminders: PropTypes.bool.isRequired,
  }

  state = {
    purchase: false,
    phoneNumberModal: {
      open: false,
      action: 'edit',
    },
    selectedBusinessId: null,
    externalOutboundNumberModal: {
      open: false,
      action: 'edit',
    },
  }

  componentDidMount() {
    const { requiresPhoneNumberPurchase, purchasedNumbers } = this.props
    if (requiresPhoneNumberPurchase && purchasedNumbers.length < 1) {
      this.setPurchasable()
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.purchasedNumbers.length < 1 &&
      this.props.purchasedNumbers.length > 0
    ) {
      this.setUnpurchasable()
    } else if (
      prevProps.purchasedNumbers.length >= 1 &&
      this.props.purchasedNumbers.length < 1
    ) {
      this.setPurchasable()
    }
  }

  handleSelectedBusiness = (id) => {
    this.setState({ selectedBusinessId: id })
  }

  toggleModal = (open, action) =>
    this.setState({ phoneNumberModal: { open, action } })

  toggleEonModal = (open, action) =>
    this.setState({ externalOutboundNumberModal: { open, action } })

  setPurchasable = () => {
    this.setState({ purchase: true })
  }
  setUnpurchasable = () => {
    this.setState({ purchase: false })
  }

  onSelect = (value) => {
    const { location, saveContactInfo } = this.props
    saveContactInfo(location.id, {
      fEmailEnd: value.trim(),
    })
  }

  onInputChange = (e) => {
    const value = !e.target.value ? null : e.target.value.trim()
    const { location, saveContactInfo } = this.props
    saveContactInfo(location.id, {
      [e.target.name]: value,
    })
  }

  onAddRecOrMsgReportChange = (e) => {
    const { location, saveContactInfo } = this.props
    saveContactInfo(location.id, {
      [e.target.name]: e.target.value,
    })
  }

  onDoctorSelect = (doctor) => {
    const { location, saveContactInfo } = this.props
    saveContactInfo(location.id, {
      doctorId: doctor,
    })
  }

  onActiveToggle = (active) => {
    const { location, saveContactInfo } = this.props
    saveContactInfo(location.id, { active: !active })
  }

  render() {
    const {
      businesses,
      buyPhoneNumbers,
      contactInfo,
      customMentionValues,
      doctors,
      emailsValidation,
      externalOutboundNumbers,
      isTopsAdmin,
      location,
      locations,
      messageReportEmails,
      pms,
      practiceId,
      purchasedNumbers,
      requiresPhoneNumberPurchase,
      showAdditionalRecipients,
      showDoctorSelect,
      dso,
      voip,
      smseUsers,
      availableExtensions,
      saveContactInfo,
      saveCustomMentionValue,
      selectedExtensions,
      updateExtensions,
      refetchLocations,
      reminders,
    } = this.props
    const {
      phoneNumberModal,
      selectedBusinessId,
      externalOutboundNumberModal,
    } = this.state
    const {
      city,
      country_code: countryCode,
      external_outbound_number_id: externalOutboundNumberId,
      id,
      name,
      office_email: officeEmail,
      office_phone: officePhone,
      state,
      street_address: streetAddress,
      timezone,
      website,
      zip,
    } = location
    const isInvalid = !emailsValidation.validStateByLocationId[id]
    const showExtensionSelection = dso && voip
    return (
      <div>
        <div className={css.wrapper}>
          <div className={css.currentContactInfo}>
            <span>{name}</span>
            <span>{streetAddress}</span>
            <span>
              {city}, {state} {zip}
            </span>
            <span>{website}</span>
            <div dangerouslySetInnerHTML={{ __html: formatReminderNumWithoutCC(officePhone, countryCode) }} />
            {/* <div>{formatReminderNumWithoutCC(officePhone, countryCode)}</div> */}
            <span>{officeEmail}</span>
            <span>{timezone}</span>
            <span>{id}</span>
            <LocationActive
              onActiveToggle={this.onActiveToggle}
              contactInfoActive={contactInfo.active}
            />
          </div>
          <div className={css.innerWrapper}>
            {pms === 'Greyfinch' && !reminders ? (
              <ExternalOutboundNumberSelect
                dso={dso}
                externalOutboundNumberModalOpen={externalOutboundNumberModal.open}
                externalOutboundNumbers={externalOutboundNumbers}
                locations={locations}
                locationId={location.id}
                outboundNumberId={externalOutboundNumberId}
                practiceId={practiceId}
                refetchLocations={refetchLocations}
                toggleEonModal={this.toggleEonModal}
                saveContactInfo={saveContactInfo}
              />
            ) : (
              <div className={css.innerWrapper}>
                {this.state.purchase ? (
                  <PhoneNumberPurchaseForm
                    businesses={businesses}
                    selectedBusinessId={selectedBusinessId}
                    handleSelectedBusiness={this.handleSelectedBusiness}
                    buyPhoneNumbers={buyPhoneNumbers}
                    countryCode={countryCode}
                    isTopsAdmin={isTopsAdmin}
                    locationId={id}
                    locations={locations}
                    phoneNumberModalOpen={phoneNumberModal.open}
                    phoneNumberModalAction={phoneNumberModal.action}
                    refetchLocations={refetchLocations}
                    toggleModal={this.toggleModal}
                  />
                ) : (
                  <ContactMapping
                    additionalRecipients={contactInfo.additionalRecipients}
                    businesses={businesses}
                    selectedBusinessId={selectedBusinessId}
                    handleSelectedBusiness={this.handleSelectedBusiness}
                    doctorId={contactInfo.doctorId}
                    doctors={doctors}
                    fEmails={[contactInfo.fEmailStart, contactInfo.fEmailEnd]}
                    isTopsAdmin={isTopsAdmin}
                    isInvalid={isInvalid}
                    locationCountryCode={countryCode}
                    locationId={id}
                    locations={locations}
                    phoneNumberModal={phoneNumberModal}
                    officeEmail={contactInfo.officeEmail}
                    officePhone={contactInfo.officePhone}
                    onAdditionalRecipientsChange={this.onAddRecOrMsgReportChange}
                    onDoctorSelect={this.onDoctorSelect}
                    onInputChange={this.onInputChange}
                    onSelect={this.onSelect}
                    pms={pms}
                    purchasedNumbers={purchasedNumbers}
                    refetchLocations={refetchLocations}
                    requiresPhoneNumberPurchase={requiresPhoneNumberPurchase}
                    showAdditionalRecipients={showAdditionalRecipients}
                    showDoctorSelect={showDoctorSelect}
                    smseUsers={smseUsers}
                    toggleModal={this.toggleModal}
                    validationError={
                      isInvalid ? emailsValidation.errors[id].errorMessage : ''
                    }
                  />
                )}
              </div>
            )}
          </div>
        </div>
        {customMentionValues.length > 0 && (
          <div className={css.innerWrapper}>
            <div className={css.customMentions}>
              <CustomMentionValues
                locationId={location.id}
                customMentionValues={customMentionValues}
                saveCustomMentionValue={saveCustomMentionValue}
              />
            </div>
          </div>
        )}
        <div className={css.innerWrapper}>
          <div className={css.extensions}>
            {showExtensionSelection && (
              <ExtensionSelection
                availableExtensions={availableExtensions}
                locationId={id}
                selectedExtensions={selectedExtensions}
                updateExtensions={updateExtensions}
              />
            )}
          </div>
          {(reminders || pms !== 'Greyfinch') && (
            <div className={css.msgReport}>
              {dso && (
                <RemindersMessageReport
                  help="Emails separated by commas. Only works if the practice is subscribed in step 2."
                  key="location-subscription"
                  label="Location Message Report Subscription Recipients"
                  name="messageReportEmails"
                  onChange={this.onAddRecOrMsgReportChange}
                  placeholder="first@example.com, second@example.com"
                  value={messageReportEmails}
                />
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default LocationRow



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/LocationRow.js